import isPlainObj from"is-plain-obj";














export const deepClone=(value)=>{
if(Array.isArray(value)){
return value.map(deepClone)
}

if(isPlainObj(value)){
return deepCloneObject(value)
}

return value
};

const deepCloneObject=(object)=>{
const copy={};


for(const key of Reflect.ownKeys(object)){
const descriptor=Object.getOwnPropertyDescriptor(object,key);
const childCopy=deepClone(descriptor.value);

Object.defineProperty(copy,key,{...descriptor,value:childCopy})
}

return copy
};